import { render, staticRenderFns } from "./FeedMessage.vue?vue&type=template&id=4497f196&scoped=true&"
import script from "./FeedMessage.vue?vue&type=script&lang=js&"
export * from "./FeedMessage.vue?vue&type=script&lang=js&"
import style0 from "./FeedMessage.vue?vue&type=style&index=0&id=4497f196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497f196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4497f196')) {
      api.createRecord('4497f196', component.options)
    } else {
      api.reload('4497f196', component.options)
    }
    module.hot.accept("./FeedMessage.vue?vue&type=template&id=4497f196&scoped=true&", function () {
      api.rerender('4497f196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/messagefeed/FeedMessage.vue"
export default component.exports